export const keypointStyles = {
  wrapper: {
    mb: {
      mobile: "5rem",
      tablet: "1.5rem",
    },
    alignItems: {
      tablet: "center",
      justifyContent: "center",
    },
    maxWidth: {
      laptop: "18rem",
      desktop: "21.875rem",
    },
    mx: {
      laptop: "0.625rem",
    },
  },
  container: {
    borderRadius: "100%",
    position: "relative",
    maxWidth: "12.625rem",
    maxHeight: "12.625rem",
    margin: {
      mobile: "0 auto 3rem",
      tablet: "0",
      laptop: "0 auto 3rem",
    },
  },
  imageWrapper: {
    position: "absolute",
    zIndex: "-1",
  },
  textContainer: {
    textAlign: {
      mobile: "center",
      tablet: "left",
      laptop: "center",
    },
    ml: {
      tablet: "2.5rem",
      laptop: "unset",
    },
  },
  title: {
    textTransform: "uppercase",
    lineHeight: {
      mobile: "1.625rem",
    },
    marginBottom: {
      mobile: "2rem",
      tablet: "1rem",
    },
  },
};
